"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Box = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isInlineCSS = (0, _styledComponents.css)(["border-top:0;border-top-left-radius:0;border-top-right-radius:0;box-shadow:0 0 0;"]);
var errorStyles = (0, _styledComponents.css)(["", " border-top-color:", ";"], _stylers["default"].errorFormStyles, _tokens["default"].border.color);

var Box = _styledComponents["default"].div.withConfig({
  displayName: "Boxstyles__Box",
  componentId: "sc-hq2ga2-0"
})(function (_ref) {
  var hasError = _ref.hasError,
      isInline = _ref.isInline,
      isReadOnly = _ref.isReadOnly,
      triggerWidth = _ref.triggerWidth;
  return (0, _styledComponents.css)(["background-color:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";box-sizing:border-box;padding:0;transition:border-color 0.2s;", " ", " ", ";", ""], _tokens["default"].color.white, _tokens["default"].border.color, _tokens["default"].border.radius, _tokens["default"].shadow, hasError && isInline ? errorStyles : "", isInline ? isInlineCSS : "", triggerWidth ? "width: ".concat(triggerWidth, "px;") : "", isReadOnly ? _stylers["default"].readOnlyFormStyles : "");
});

exports.Box = Box;
//# sourceMappingURL=Box.styles.js.map